export default function apiHeader() {
  const token = localStorage.getItem("token") || "{}";

  if (token) {
    return { Authorization: token };
  } else {
    return {};
  }
}
